import { ref } from "vue";
import { wapiClient } from "@/services/wapi";

function useAutUserMedia() {
  const authUserMedia = ref<any | null>(null);

  async function fetchAuthUserMedia(mediaId: number) {
    const { data: authUserMediaData, execute: executeFetchAuthUserMedia } =
      wapiClient("/wapi/auth/medias/" + mediaId, {
        immediate: false,
      }).json();

    await executeFetchAuthUserMedia();
    if (authUserMediaData.value.data) {
      authUserMedia.value = authUserMediaData.value.data;
    }
  }

  return {
    fetchAuthUserMedia,
    authUserMedia,
  };
}

export default useAutUserMedia;
